<template>
  <div class="bookListDetail">
    <div class="seciton">
      <div class="section_title">
        <div class="box">
          <div class="left">
            <van-image class="img" :src="detail.image"></van-image>
          </div>
          <div class="right">
            <div class="top">
              <div class="title">{{ detail.name }}</div>
            </div>
            <div class="bottom">
              <div class="message">
                <span>阅读：{{ detail.viewNum }}</span>
                <span class="two">收藏：{{ detail.collectionCount }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div class="section_bottom">
         <div class="title">简介</div>
         <div class="text" v-html="detail.content"></div>
      </div>
    </div>


    <!-- 底部列表开始 -->
    <div class="fixed">
      <div class="box">
        <div class="box_left">
          <ul class="list">
            <li class="list_item"
              v-for="(item, index) in operations"
              :key="index"
              @click="itemClick(index)"
            >
              <i class="icon" :class="{'active': detail.isCollected}"></i>
              <div class="text" v-if="detail.isCollected">{{ item.activeText }}</div>
              <div class="text" v-else>{{ item.text }}</div>
            </li>
          </ul>
        </div>
        <div class="box_right" >
          <div class="btn" @click="toRed">立即阅读</div>
        </div>
      </div>

    </div>
    <!-- 底部列表结束 -->
  </div>
</template>

<script>
import { Dialog } from 'vant';
export default {
  components: {

  },
  data () {
    return {
      id: '',
      contlll: '123456',
      operations: [
        {
          src: require('@/assets/images/book/icon_star_01.png'),
          active: require('@/assets/images/book/icon_star_02.png'),
          text: '收藏',
          activeText: '已收藏'
        }
      ],
      detail: {}
    };
  },
  computed: {

  },
  created () {

  },
  mounted () {
    const { $route: { query: { id } } } = this;
    this.id = id * 1;

    this.getDetail();
  },
  methods: {

    /* 获取详情信息 */
    getDetail () {
      const { $http, id, $router } = this;
      if (id) {
        $http.get('books/detail', {
          params: {
            id
          }
        }).then((res) => {
          console.log("res", res);
          this.detail = res.data || {};
          // 判断该书是否需要
          if (this.detail != null && this.detail.code == -1){
            // 需要登录但没有登录的情况
            // 这里执行跳转弹窗提示
            Dialog.confirm({
              title: '提示',
              message: '该书需要登录才能查看，是否登录',
              confirmButtonText: '去登录',
            }).then(() => {
              // 点击确认按钮事件处理
              console.log("点击了确认按钮");
              $router.push({
                name: 'Login',
                query: { redirect: '/bookListDetail?id='+id } // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
              });
            }).catch(() => {
              // 点击取消按钮事件处理
              history.go(-1);
            });
          }
          this.$wxShare({
            // url: window.href, // 网址，默认使用 window.location.href
            title: this.detail.name, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
            desc: this.detail.content || '广东教育出版社', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
            imgUrl: this.detail.image // 图片, 默认取网页中第一个img标签
          });
        });
      }
    },

    /* 点击收藏按钮 */
    itemClick () {
      let { $utils, $http, id, $router } = this;
      // console.log("utils",$utils.storage.get('loginToken'));
      if ($utils.storage.get('loginToken')){
        $router.push({
          name: 'Login',
          query: { redirect: '/bookListDetail?id='+id } // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
        });
      }

      $http.post('books/collect', {
        id
      }, {
        showLoading: true
      }).then((res) => {
        this.detail.isCollected = !this.detail.isCollected;
        this.detail.isCollected ? $utils.toast('收藏成功') : $utils.toast('取消收藏');
      });
    },

    /* 去阅读 */
    toRed () {
      const { detail, $router, id } = this;
      // 判断书本是否为需要登录但没有登录
      if (this.detail != null && this.detail.code == -1){
        $router.push({
          name: 'Login',
          query: { redirect: '/bookListDetail?id='+id } // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
        });
      }
      if (detail.bookType === 1) {
        if(detail.bookHref === "#"){
          // this.$message('暂未配置');
          this.$utils.toast('暂未配置');
        }else{
          // 链接形式的书本
          window.open(detail.bookHref);
        }
      } else if (detail.bookType === 2) {
        // 文件形式的书本
        $router.push({ name: 'BookShelfRead', query: { detail } });
      }
    }
  }
};
</script>

<style scoped lang="less">
  .bookListDetail{
    /*padding: 10px 0 0;*/
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    .seciton{
      /*margin-top: 40px;*/
      margin-bottom: 150px;
      .section_title{
        .box{
          width: 100%;
          background: #F7F8FC;
          border-radius: 16px;
          padding: 20px 36px 38px;
          display: flex;
          margin-bottom: 60px;
          .left{
            width: 168px;
            height: 180px;
            /*margin-top: -20px;*/
            margin-right: 40px;
            position: relative;
            z-index: 2;
            background-color: #fff;
            .img{
              width: 100%;
              height: 100%;
              /*height: auto;*/
              background: #FFFFFF;
              border-radius: 16px;
              overflow: hidden;
              position: relative;
              z-index: 9;
            }
            &::after{
              content: "";
              position: absolute;
              margin: 0 auto;
              z-index: 1;
              text-align: center;
              border-radius:0 0 16px 16px;
              display: block;
              height: 10px;
              width: 90%;
              left: 0;
              right: 0;
              bottom: -5px;
              background: #000000;
              box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.74);
              opacity: 0.15;
            }
          }
          .right{
            font-size: 32px;
            color: #333444;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .top{
              .title{
                font-weight: bold;
                margin-bottom: 8px;
              }
              .text{
                font-size: 26px;
                color: #999AAA;

              }
            }
            .bottom{
              font-size: 26px;
              color: #666666;
              .two{
                margin-left: 16px;
              }
            }
          }
        }
      }
      .section_bottom{
        .title{
          font-size: 32px;
          font-weight: bold;
          color: #333444;
          display: flex;
          align-items: center;
          margin-bottom: 40px;
          &::before{
            content: "";
            width: 8px;
            height: 32px;
            background: #5FA9FF;
            border-radius: 4px;
            display: inline-block;
            margin-right: 20px;
          }
        }
        .text{
          font-size: 26px;
          color: #67677A;
          line-height: 48px;
        }
      }

    }
    .fixed{
      padding: 12px 36px;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100px;
      background: #fff;
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.04);
      .box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        .box_left{
          .list{
            display: flex;
            align-items: center;
            .list_item{
              display: flex;
              align-items: center;
              flex-direction: column;
              .icon{
                width: 32px;
                height: 32px;
                margin-bottom: 4px;
                background-image: url('~@/assets/images/book/icon_star_01.png');
                background-size: contain;
                &.active{
                  background-image: url('~@/assets/images/book/icon_star_02.png');
                }
              }
              .text{
                font-size: 20px;
                line-height: 28px;
                color: #333444;
              }
            }
          }
        }
        .box_right{
          .btn{
            width: 450px;
            border-radius: 44px;
            font-size: 26px;
            height: 76px;
            color: #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            background: linear-gradient(90deg, #2E86FF 0%, #5FA9FF 100%);
            box-shadow: 0px 6px 12px rgba(79, 157, 255, 0.2);
          }
        }
      }
    }
  }
</style>
